import React from 'react'

// Components
import FormContact from 'components/flex/Form/FormContact'
import FormInquiries from 'components/flex/Form/FormInquiries'

interface FormShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Form
  location?: any
}

interface PostProps {
  [key: string]: any
}

const FormShell: React.FC<FormShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    contact: FormContact,
    inquiry: FormInquiries,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default FormShell
